module.exports = __webpack_public_path__ + "img/edifier-logo-black.27167e31.svg";